import api from './api';

const suppliersService = {
  // Buscar todos os fornecedores
  getAllSuppliers: async (params = {}) => {
    try {
      const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined)
      );
      const response = await api.get('/suppliers', { params: cleanParams });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar fornecedores:', error);
      throw error;
    }
  },

  // Buscar fornecedor por ID
  getSupplierById: async (id) => {
    try {
      const response = await api.get(`/suppliers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar fornecedor:', error);
      throw error;
    }
  },

  // Criar novo fornecedor
  createSupplier: async (supplierData) => {
    try {
      const response = await api.post('/suppliers', supplierData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar fornecedor:', error);
      throw error;
    }
  },

  // Atualizar fornecedor
  updateSupplier: async (id, supplierData) => {
    try {
      const response = await api.put(`/suppliers/${id}`, supplierData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar fornecedor:', error);
      throw error;
    }
  },

  // Soft delete fornecedor (desativa)
  deleteSupplier: async (id) => {
    try {
      const response = await api.patch(`/suppliers/${id}`, { is_active: false });
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar fornecedor:', error);
      throw error;
    }
  }
};

export default suppliersService;
